import { Box, LinearProgress, SxProps, Typography } from '@mui/material';
import * as Preact from 'preact';
import * as QrCode from './A_QrCode';
import * as ActionBarModal from './O_ActionBarModal';
import { useTranslations } from './utils/TranslationsWrapper';

export interface ArProps {
    mode: 'ar';
    onLaunchClick: () => void;
    launchText: string;
    loading: boolean;
}

export interface QrProps {
    mode: 'qr';
    qrCode: string;
    loading: boolean;
}

export interface Props {
    open: boolean;
    title: string;
    onCloseClick: () => void;
    sx: SxProps;
}

export const Component = (props: Props & (ArProps | QrProps)) => {

    const { t } = useTranslations();

    return (
        <ActionBarModal.Component
            open={props.open}
            sx={props.sx}
            title={props.title}
            onCloseClick={props.onCloseClick}
            actionBar={
                props.mode === 'ar'
                    ? {
                          primary: {
                              onActionClick: props.onLaunchClick,
                              actionText: props.launchText,
                              actionLoading: props.loading,
                          },
                      }
                    : undefined
            }
        >
            {
                /**
                 * The LinearProgress component doesn't operate correctly inside the Box, so we figure out if we need to show that first */
                props.mode === 'qr' && props.loading === true ? (
                    <LinearProgress />
                ) : (
                    <Box display="flex" alignItems="center" justifyContent="center" padding="24px">
                        {props.mode === 'ar' ? (
                            <Typography textAlign="center" variant="body3" color="secondary">
                                {t('ar.launch.instructions')}
                            </Typography>
                        ) : (
                            <QrCode.Component url={props.qrCode} />
                        )}
                    </Box>
                )
            }
        </ActionBarModal.Component>
    );
};

Component.displayName = 'ArModal';
